import Icon from './Icon';
import { SUPPORT_HOURS, SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';

export default function BigCta() {
  return (
    <section className="section section--dark">
      <div className="container">
        <div className="bigcta">
          <p className="kicker" style={{ justifyContent: 'center' }}>
            Ready When You Are
          </p>
          <h2 className="bigcta__title">
            Best Price on McAfee.
            <span>Call and Save Now.</span>
          </h2>
          <p className="bigcta__text">
            Speak to a specialist about the right plan for your devices. We confirm pricing, apply
            the current discount, and stay with you through installation.
          </p>

          <div className="bigcta__actions">
            <a className="call-btn" href={`tel:${SUPPORT_PHONE_TEL}`}>
              <span className="call-btn__icon">
                <Icon name="phone" size={22} strokeWidth={2} />
              </span>
              <span className="call-btn__text">
                <span className="call-btn__num">{SUPPORT_PHONE}</span>
                <span className="call-btn__label">Toll-free · No wait times</span>
              </span>
            </a>
            <p className="bigcta__fine">{SUPPORT_HOURS}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
